import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Maybe } from '@iss/libs/graphql';
import { ChangeDetectorRef, Injectable, OnDestroy, PipeTransform } from '@angular/core';

@Injectable()
export abstract class BaseEnumTranslationPipe<T extends string> implements PipeTransform, OnDestroy {
  private readonly translatePipe: TranslatePipe;

  protected abstract readonly translationPrefix: string;

  protected constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.translatePipe = new TranslatePipe(translateService, changeDetectorRef);
  }

  public transform(value: Maybe<T>): string {
    return this.translatePipe.transform(
      value ? `${this.translationPrefix}.${ value }` : '',
    ) as string;
  }

  public ngOnDestroy(): void {
    this.translatePipe.ngOnDestroy();
  }
}
